import { API } from './api';

export const sendVerificatonEmail = () => {
  return API().post('email/send_email_verification');
};

export const updateEmail = (email) => {
  return API().post('email/update_email', { email });
};

export const verifyEmail = (email_code, user_id) => {
  return API().post('email/verify_email', { email_code, user_id });
};
